package ui.campaign.detailv2.editor.page

import androidx.compose.runtime.Composable
import ui.campaign.detailv2.editor.CampaignEditorScope

@Composable
fun CampaignEditorScope.CampaignPage05Effect() {

}